export default {"src":"/_next/static/media/fast.a3daf8bb.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};